import {getRequest, putRequest, postRequest} from './apiRequests';
import {DisputeDto} from '@/domain/entities/Dispute';

const disputeRepository = {
  getDisputesForParcel: (parcelUuid: string): Promise<Array<DisputeDto>> => {
    return getRequest<Array<DisputeDto>>({
      path: `disputes/?parcelUuid=${parcelUuid}`
    });
  },
  createDispute: (dispute: Partial<DisputeDto>) => {
    return postRequest<DisputeDto>({
      path: 'disputes/',
      body: dispute
    });
  },
  updateDispute: (dispute: Partial<DisputeDto>) => {
    return putRequest<DisputeDto>({
      path: `disputes/${dispute.uuid}/`,
      body: dispute
    });
  }
};

export default disputeRepository;